<template lang="pug">
section(v-bind:class="sectionClass")
	.section-content
		.has-text-centered
			.title.is-spaced.is-spaced-bottom {{ $t('home.title4') }}

		.columns.column-text-center.is-vcentered
			.column.is-7-desktop.is-8-tablet
				strong.subtitle {{ $t('home.subtitle4_1') }}
				p.subtitle.no-line-break-mobile.subtitle-right-padding
					| {{ $t('home.content4_l1_1') + ' ' }}
				.showreel-outer: .showreel-container
					.showreel.showreel-class
			.column.is-3-desktop.is-3-tablet
				img.features-phone(src="/img/features/phone-lesson.png")

		.columns.column-text-center.is-vcentered
			.column.is-3-desktop.is-3-tablet
				img.features-phone(src="/img/features/phone-workout.png")
			.column.is-7-desktop.is-8-tablet
				strong.subtitle.subtitle-left-padding {{ $t('home.subtitle4_8') }}
				p.subtitle.no-line-break-mobile.subtitle-left-padding
					| {{ $t('home.content4_l8_1') + ' ' }}

		.columns.column-text-center.is-vcentered
			.column.is-7-desktop.is-8-tablet
				strong.subtitle {{ $t('home.subtitle4_2') }}
				p.subtitle.no-line-break-mobile.subtitle-right-padding
					| {{ $t('home.content4_l2_1') + ' ' }}
				.showreel-outer: .showreel-container
					.showreel.showreel-challenge
			.column.is-3-desktop.is-3-tablet
				img.features-phone(src="/img/features/phone-challenge.png")

		.columns.column-text-center.is-vcentered
			.column.is-3-desktop.is-3-tablet
				img.features-phone(src="/img/features/phone-colleagues.png")
			.column.is-7-desktop.is-8-tablet
				strong.subtitle.subtitle-left-padding {{ $t('home.subtitle4_3') }}
				p.subtitle.no-line-break-mobile.subtitle-left-padding
					| {{ $t('home.content4_l3_1') + ' ' }}

		.columns.column-text-center.is-vcentered
			.column.is-7-desktop.is-8-tablet
				strong.subtitle {{ $t('home.subtitle4_4') }}
				p.subtitle.no-line-break-mobile.subtitle-right-padding
					| {{ $t('home.content4_l4_1') + ' ' }}
			.column.is-3-desktop.is-3-tablet
				img.features-phone(src="/img/features/phone-achievement.png")

		.columns.column-text-center.is-vcentered
			.column.is-3-desktop.is-3-tablet
				img.features-phone(src="/img/features/phone-ranking.png")
			.column.is-7-desktop.is-8-tablet
				strong.subtitle.subtitle-left-padding {{ $t('home.subtitle4_5') }}
				p.subtitle.no-line-break-mobile.subtitle-left-padding
					| {{ $t('home.content4_l5_1') + ' ' }}

		.columns.column-text-center.is-vcentered
			.column.is-7-desktop.is-8-tablet
				strong.subtitle {{ $t('home.subtitle4_6') }}
				p.subtitle.no-line-break-mobile.subtitle-right-padding
					| {{ $t('home.content4_l6_1') + ' ' }}
			.column.is-3-desktop.is-3-tablet
				img.features-phone(src="/img/features/phone-profile.png")

		.columns.column-text-center.is-vcentered
			.column.is-3-desktop.is-3-tablet
				img.features-phone(src="/img/features/phone-blog.png")
			.column.is-7-desktop.is-8-tablet
				strong.subtitle.subtitle-left-padding {{ $t('home.subtitle4_7') }}
				p.subtitle.no-line-break-mobile.subtitle-left-padding
					| {{ $t('home.content4_l7_1') + ' ' }}
</template>

<script>
export default {
	name : 'SectionFeatures',
	props: {
		num: Number
	},
	computed: {
		sectionClass() {
			return {
				'section'                : true,
				'border-bottom-section'  : true,
				'section-background-grey': this.num % 2 === 0
			}
		}
	}
}
</script>
